import {useEffect} from "react";

/**
 * @desc step 1730: the list of usable function is here
 */


/**
 * @desc step 1730-1: function to slugify string, remove space and replace - to use in url
 */
export const slugify = (str) => {
    const array = str.split(' ');
    const sliced = array.splice(0, 5);
    return sliced.join('-');
}

/**
 * @desc step 1730-2: function to get form data and convert it to json
 */
export const formDataToJson = (formData) => {
    let object = {};
    formData.forEach(function (value, key) {
        object[key] = value;
    });
    return object;
}

/**
 * @desc step 1730-3: function to make clone from an object
 */
export const cloneObject = (object) => {
    return (JSON.parse(JSON.stringify(object)))
}

/**
 * @desc step 1730-4: function to make querystring from json
 */
export const objectToQueryString = (object) => {
    let keys = object ? Object.keys(object) : [];
    let queryString = [];
    if (keys.length) {
        for (const key of keys) {
            queryString.push(key + "=" + object[key]);
        }
    }

    return (queryString.length ? '?' : '') + queryString.join('&');
}

/**
 * @desc step 1730-5: function to check variable is number
 */
export const isNumber = (num) => {
    return !isNaN(parseInt(num));
}

/**
 * @desc step 1730-6: function to check time of day
 */
export const greetByTime = () => {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    let greeting;

    if (currentHour < 12) {
        greeting = 'Good Morning';
    } else if (currentHour < 18) {
        greeting = 'Good Afternoon';
    } else {
        greeting = 'Good Evening';
    }

    return greeting;
}


export const useOutsideAlerter = (ref, setOpen) => {
    useEffect(() => {

        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setOpen]);
}


/**
 * @desc step 1730-7: function change string to camelcase
 */
export default function toCamelCase(str) {
    // Split the string by hyphens and underscores
    const words = str.split(/[-_]/);

    // Convert the first word to lowercase and capitalize the rest
    const camelCaseWords = words.map((word, index) => {

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

    // Join the words to form the camel case string
    return camelCaseWords.join('');
}

export const truncate = (source, size) => {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
}

export const timeAgo = (inputDate) => {
    let date = new Date(inputDate);
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
        return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
        return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
}

export const panelToUrl = (panel) => {
    const path = process.env[`REACT_APP_${panel.toUpperCase()}_URL`];
    const port = process.env[`REACT_APP_${panel.toUpperCase()}_PORT`];
    const strippedUrl = path.replace(/^https?:\/\//, '');

    const isDomain = !/^\d{1,3}(\.\d{1,3}){3}$/.test(strippedUrl);

    return isDomain
        ? `${path}/${port}` // For domain
        : `${path}:${port}`;
}

// Function to get label by value
export const getItemsLabel = (items,value) => {
    const layout = items.find((layout) => layout.value === value);
    return layout ? layout.label : "Unknown";
};